import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ViewRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CardView } from 'src/app/interfaces/cardview';
import { HTTPService } from 'src/app/services/http.service';

@Component({
    selector: 'privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: false
})
export class PrivacyComponent implements OnInit, AfterViewInit {

  
  constructor(private http:HTTPService,private routerParam:ActivatedRoute, private cd:ChangeDetectorRef) {
    
   }

  ngOnInit() {
     
  }

  ngAfterViewInit(){
  }

  ngOnDestroy(){
    this.cd.detach();
  }

}
